module.exports = __webpack_public_path__ + "static/img/redPackage.9617742c.png";